import { render, staticRenderFns } from "./ProductsModal.vue?vue&type=template&id=42375df1&scoped=true"
import script from "./ProductsModal.vue?vue&type=script&lang=js"
export * from "./ProductsModal.vue?vue&type=script&lang=js"
import style0 from "./ProductsModal.vue?vue&type=style&index=0&id=42375df1&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42375df1",
  null
  
)

export default component.exports